import React from "react";
import { deleteIcon } from "assets";
import Icon from "components/Icon";

// Компонент для видалення елементу
const DeleteButton = ({ onDelete, disabled = false }) => {
  return (
    <button onClick={onDelete} title="Видалити" disabled={disabled}>
      <Icon src={deleteIcon} className="mask-delete" />
    </button>
  );
};

export default DeleteButton;
